import {Component} from 'react';
import phoneimage from './img/appels-telephone.png';
class phoneBlock extends Component {


	render(){
		return (
			<a href="tel:0891150451" className="phone-link" ><div className="phone-block">
				<p className="phone-text">Une question concernant l’indemnité carburant ?<br/>Contactez un de nos spécialistes</p>
				<img src={phoneimage} className="phone-image" />
			</div>
			</a>
		);

	}
}
export default phoneBlock;